import Loadable from '../../components/loadable';

const SendTestEmailModal = Loadable({
  loader: () => import('../../pages/messages/send_test_email_modal'),
  type: 'modal',
});

angular.module('shared').value('SendTestEmailModal', SendTestEmailModal);
